/* eslint-disable max-len */
import React from 'react';

import { Backdrop } from '@/kaya';
import { userActions } from '@/actions';
import image from '../../assets/email.png';

import styles from './emailConfirmation.module.scss';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  email: string;
}

const EmailConfirmation = (props: Props) => {
  const { visible, setVisible, email } = props;

  const handleResend = async () => {
    const isSucess = await userActions.resendVerificationEmailAction({ payload: { email } });
    if (isSucess) {
      setVisible(false);
    }
  };
  return visible ? (
    <div>
      <Backdrop visible={visible} setVisible={setVisible} />
      <div className={styles.emailConfirmation}>
        <img src={image} alt="" />
        <p className={styles.confirmation}>Email Confirmation</p>
        <p className={styles.desc}>
          We have sent an email to <span className={styles.email}>{email}.</span>
          {
            ' Please verify \n  your email address to go further. Follow the steps shown in the email'
          }
        </p>
        <p className={styles.question}>Don&apos;t see the email? Check your spam folder.</p>

        <p className={styles.question}>
          Didn&apos;t receive an email?{' '}
          <a className={styles.resent} onClick={handleResend}>
            {' '}
            Resend It
          </a>
        </p>
      </div>
    </div>
  ) : null;
};

export default EmailConfirmation;
